module.exports = __webpack_public_path__ + "static/media/lulizollo.63bc98d9.png";